<template>
        <div class="container">
            <div class="search-box-dropdown">
                <BlockEventDropdown withSearch/>
                <BlockSearchBox withFilter/>
            </div>
        </div>
</template>

<script>
    import BlockEventDropdown from './BlockEventDropdown.vue';
    import BlockSearchBox from './BlockSearchBox.vue';
    export default {
        components: {
            BlockSearchBox,
            BlockEventDropdown
        }
    };
</script>

<style lang="scss" scoped>
    .search-box-dropdown {
        display: flex;
        margin-top: 30px;
        .event-dropdown {
            z-index: 1;
        }
        .search-box {
            width: calc(100% - 246px);
            margin-left: -24px;
        }
         @include mq($md) {
            flex-direction: column-reverse;
            .search-box {
                width: 100%;
                margin-left: 0;
                margin-bottom: 20px;
            }
        }
    }
</style>
